import {
  InputHTMLAttributes,
  RefObject,
  useEffect,
  useMemo,
  useRef
} from 'react'

import { useMemoizedFn } from 'ahooks'
import { noop } from 'lodash'

type InputAttrsWithRef = InputHTMLAttributes<HTMLInputElement> & {
  ref: RefObject<HTMLInputElement | null>
}

export const useFileDialog = (callback: (files: File[]) => void = noop) => {
  const ref = useRef<HTMLInputElement>(null)

  const attrs = useMemo<InputAttrsWithRef>(
    () => ({
      ref,
      style: { display: 'none' },
      type: 'file'
    }),
    []
  )

  const memoizedCallback = useMemoizedFn(callback)

  const openFileDialog = useMemoizedFn(() => {
    ref.current?.click()
  })

  useEffect(() => {
    const input = ref.current

    if (!input) {
      console.warn('useUpload: input is not exist')
      return
    }

    const handleFileChange = async (event: Event) => {
      const files = (event.target as HTMLInputElement)?.files
      if (files) {
        memoizedCallback?.([...files])
        input.value = ''
      }
    }

    input.addEventListener('change', handleFileChange)

    return () => {
      input.removeEventListener('change', handleFileChange)
    }
  }, [memoizedCallback])

  return {
    attrs,
    openFileDialog
  }
}
